<template>
    <div class="box">
        <proposal-list-row
                v-for="proposal in proposals"
                :proposal="proposal"
                :key="proposal.id" />
    </div>
</template>
<script>
    import ProposalListRow from "./ProposalListRow.vue";

    export default {

        /**
         * The component name
         *
         * @type {string}
         */
        name: 'ProposalList',

        /**
         * The child components
         *
         * @type {object}
         */
        components: {
            ProposalListRow
        },

        /**
         * The computed properties
         *
         * @type {object}
         */
        computed: {

            /**
             * The campaign id
             *
             * @returns {string}
             */
            campaign_id() {
                return this.$route.params.campaign_id;
            },

            /**
             * The campaign
             *
             * @returns {object}
             */
            campaign() {
                return this.$root.getCampaign(this.campaign_id);
            },

            /**
             * The proposals
             *
             * @returns {array}
             */
            proposals() {
                return this.$root.campaignProposals(this.campaign_id)
            }
        },

        /**
         * When the component is created
         *
         * @type {function}
         */
        created() {

            let proposals = this.$root.campaignProposals(this.campaign_id);

            if (!proposals.length) {
                return this.$root.go('sponsorships');
            }

            /*
            proposals.forEach(proposal => {
                if(this.$root.getJobs(proposal.id).length) {
                    return this.$root.go('job', { proposal_id: proposal.id })
                }
            });
            */
        }
    }
</script>

